export default function () {
  const audio = <HTMLAudioElement>document.getElementById("keyreply-notification-sound");
  if (audio) {
    audio.muted = false;
    audio?.play();
  }
}
